import { CampaignType } from '@dev/ee-api/ee-api-models';
import { WithTranslation } from 'react-i18next';
import { RouteComponentProps } from 'react-router-dom';

import { ExportLinksParams } from '../../../../services/ElasticApi';

interface ViewUrlParams {
    type: CampaignType;
    name: string;
}

export interface CampaignReportLinksProps extends WithTranslation, RouteComponentProps<ViewUrlParams> {}

export enum LinkToggleBtnValues {
    Map = 'map',
    List = 'list',
}
export interface LinksToggleBtnOptInterface {
    label: string;
    value: LinkToggleBtnValues;
}

export interface LinksState {
    linksActivePage: number;
    linksPerPage: number;
    toggleButtonValue: LinkToggleBtnValues;
    exportOptions: ExportLinksParams;
}
